import React from 'react';

import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: '32px',
    padding: '28px',
    borderRadius: '24px',
    background: `linear-gradient(135deg, ${theme.palette.offWhite.main} 0%, ${theme.palette.white.main} 100%)`,
    border: `1px solid ${theme.palette.grayScale5.main}`,
    boxShadow: '0 20px 45px rgba(31, 41, 55, 0.08)',
    position: 'relative',

    [theme.breakpoints.down('xs')]: {
      marginBottom: '24px',
      padding: '20px',
      borderRadius: '18px',
    },
  },
  content: {
    position: 'relative',
    zIndex: 1,
  },
  accentBar: {
    width: '72px',
    height: '6px',
    marginBottom: '18px',
    borderRadius: '999px',
    background: `linear-gradient(90deg, ${theme.palette.orange.main} 0%, ${theme.palette.orange.main} 55%, rgba(255,255,255,0) 100%)`,
  },
  label: {
    marginBottom: '8px',
    color: theme.palette.orange.main,
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '0.12em',
    lineHeight: '16px',
    textTransform: 'uppercase',
  },
  title: {
    marginBottom: '24px',
    color: theme.palette.darkGray.main,
    fontSize: '30px',
    fontWeight: 600,
    lineHeight: '40px',
    fontFamily: 'Montserrat',

    [theme.breakpoints.down('xs')]: {
      fontSize: '26px',
      lineHeight: '34px',
    },
  },
  stepsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: '14px',
    marginBottom: '18px',

    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  stepCard: {
    minHeight: '100%',
    padding: '16px 18px',
    borderRadius: '18px',
    backgroundColor: theme.palette.white.main,
    border: `1px solid ${theme.palette.grayScale4.main}`,
    boxShadow: '0 10px 24px rgba(31, 41, 55, 0.08)',
  },
  stepNumber: {
    width: '34px',
    height: '34px',
    marginBottom: '12px',
    borderRadius: '10px',
    backgroundColor: theme.palette.orange.main,
    color: theme.palette.white.main,
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '34px',
    textAlign: 'center',
    fontFamily: 'Montserrat',
  },
  stepText: {
    color: theme.palette.darkGray.main,
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: '23px',
  },
  footnote: {
    color: theme.palette.darkGray.main,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '22px',
    opacity: 0.8,
  },
  footnoteHighlight: {
    color: theme.palette.orange.main,
    fontWeight: 700,
  },
}));

type Props = {
  label: string;
  title: string;
  steps: string[];
  reassuranceText: string;
};

const PublicLaunchIntro = ({
  label,
  title,
  steps,
  reassuranceText,
}: Props) => {
  const classes = useStyles();

  return (
    <section className={classes.root}>
      <div className={classes.content}>
        <div className={classes.accentBar} />
        <Typography className={classes.label}>{label}</Typography>
        <Typography className={classes.title}>{title}</Typography>

        <div className={classes.stepsGrid}>
          {steps.map((step, index) => (
            <Box key={step} className={classes.stepCard}>
              <div className={classes.stepNumber}>{index + 1}</div>
              <Typography className={classes.stepText}>{step}</Typography>
            </Box>
          ))}
        </div>

        <Typography className={classes.footnote}>
          <span className={classes.footnoteHighlight}>What happens next:</span>
          {' '}
          {reassuranceText}
        </Typography>
      </div>
    </section>
  );
};

export default PublicLaunchIntro;
